import React from 'react';
import {orderBy} from 'lodash';
import Base from './Base';

const ENTITY = 'news';
export const REDUCER_NAME = ENTITY;

const initialState = {isFetching: true, isSingleObject: false, values: []};


class News extends Base {
  constructor(...props) {
    super(...props);
  }

  mapper(response) {
    const result = response.map((obj) => {
      const section_images = (obj.section_images || []).map((obj) => {
        obj.component = 'Image';
        return obj;
      });
      const section_texts = (obj.section_texts || []).map((obj) => {
        obj.component = 'Text';
        return obj;
      });

      const section_lists = (obj.section_lists || []).map((obj) => {
        obj.component = 'List';
        return obj;
      });

      obj.gallery = obj.gallery === '' ? [] : JSON.parse(obj.gallery);

      obj.sections = orderBy([...section_images, ...section_texts, ...section_lists], ['position'], ['asc']);
      return obj;
    });
    return result;
  }

  getAsync(url) {
    const self = this;

    const options = {
      method: 'GET',
      headers: this.headers()
    };

    return (dispatch) => {
      dispatch(this.fetch());
      return fetch(`${this.baseUrl}/${url}`, options)
        .then((response) => {
          if (response.status > 400) {
            return false;
          }
          return response.json();
        })
        .then((response) => {

          dispatch(this.get(self.mapper(response)));
          return response;
        })
        .catch((e) => {
          console.log(e);
          dispatch(errorAction());
          throw e;
        });
    };
  }
}


const news = new News(ENTITY, initialState, true);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);
news.putAsync.bind(news);
news.postAsync.bind(news);

export const get = () => {
  return news.getAsync(`${ENTITY}`);
};

export const post = (data) => {
  return news.postAsync(`${ENTITY}`, data);
};

export const put = (id, data) => {
  return news.putAsync(`${ENTITY}/${id}`, data);
};

export const del = (id) => {
  return news.deleteAsync(`${ENTITY}/${id}`);
};



// WEBPACK FOOTER //
// ./src/redux/modules/news.js